/* Vordefinierte Karten: die Texte werden mit eingebunden. Die erste ist die Standardkarte beim ersten Start, die zweite bleibt zum Vergleich wählbar. */
import arena from 'virtual:xf-sample/breezy_bytes_arena';
import breezy from 'virtual:xf-sample/breezy_bytes';

export const SAMPLE_TEXT = { 'sample-arena': arena, 'sample-breezy': breezy };
